<template>
  <div class="flex justify-between gap-8">
    <div
      class="flex gap-4 relative items-center ripple"
      :class="{ 'grayscale opacity-50 pointer-events-none': !isShortcutAvailable('fund') }"
      @click="
        $bus.emit($constants.EVENTS.SERVICES.START, {
          group: 'recharges',
          option: 'fund'
        })
      "
    >
      <div class="">
        <div class="flex flex-col gap-2 items-center text-2xl">
          <div class="w-18 h-18 bg-[#070C4C] rounded-full p-5">
            <ColorImg
              class="w-full h-full bg-white"
              alt=""
              src="/images/servicesOptions/fund.svg"
            />
          </div>
          <div class="text-lg">Recharge</div>
        </div>
      </div>
    </div>
    <div
      class="flex gap-4 relative items-center ripple"
      :class="{ 'grayscale opacity-50 pointer-events-none': !isShortcutAvailable('withdraw') }"
      @click="
        $bus.emit($constants.EVENTS.SERVICES.START, {
          group: 'recharges',
          option: 'withdraw'
        })
      "
    >
      <div class="">
        <div class="flex flex-col gap-2 items-center text-2xl">
          <div class="w-18 h-18 bg-[#070C4C] rounded-full p-5">
            <ColorImg
              class="w-full h-full bg-white"
              alt=""
              src="/images/servicesOptions/withdraw.svg"
            />
          </div>
          <div class="text-lg">Retrait</div>
        </div>
      </div>
    </div>
    <div
      class="flex gap-4 relative items-center ripple"
      :class="{ 'grayscale opacity-50 pointer-events-none': !isShortcutAvailable('buy') }"
      @click="
        $bus.emit($constants.EVENTS.SERVICES.START, {
          group: 'trade',
          option: 'buy'
        })
      "
    >
      <div class="">
        <div class="flex flex-col gap-2 items-center text-2xl">
          <div class="w-18 h-18 bg-[#070C4C] rounded-full p-5">
            <ColorImg
              class="w-full h-full bg-white"
              alt=""
              src="/images/servicesOptions/buy.svg"
            />
          </div>
          <div class="text-lg">Achat</div>
        </div>
      </div>
    </div>
    <div
      class="flex gap-4 relative items-center ripple"
      :class="{ 'grayscale opacity-50 pointer-events-none': !isShortcutAvailable('sell') }"
      @click="
        $bus.emit($constants.EVENTS.SERVICES.START, {
          group: 'trade',
          option: 'sell'
        })
      "
    >
      <div class="">
        <div class="flex flex-col gap-2 items-center text-2xl">
          <div class="w-18 h-18 bg-[#070C4C] rounded-full p-5">
            <ColorImg
              class="w-full h-full bg-white"
              alt=""
              src="/images/servicesOptions/sell.svg"
            />
          </div>
          <div class="text-lg">Vente</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getCurrentInstance } from 'vue';
const { proxy } = getCurrentInstance();
const { $stores } = proxy;

const isShortcutAvailable = (type) => {
  const countryCode = $stores.user.state.current?.countryCode;
  const appData = $stores.appData.state.data;
  const availability = appData?.serviceAvailability?.[countryCode];
  if (!availability) return true;

  if (type === 'fund') {
    return (
      availability.fund1xBet ||
      availability.fundBetWinner ||
      availability.fund1Win ||
      availability.fundMelbet ||
      availability.fundEightStarz
    );
  }
  if (type === 'withdraw') {
    return (
      availability.withdrawal1xBet ||
      availability.withdrawalBetWinner ||
      availability.withdrawal1Win ||
      availability.withdrawalMelbet ||
      availability.withdrawalEightStarz
    );
  }
  if (type === 'buy') return availability.buyUsdt;
  if (type === 'sell') return availability.sellUsdt;

  return true;
};
</script>
